<template>
  <div class="eventDetail">
    <Breadcrumb />
    <el-main>
      <EventDesc />
      <el-row class="nofull event_content">
        <EventMenu :menuActiveId="menuActiveId" />
        <el-main>
          <div
            class="contentEmpty"
            v-if="
              eventDesc.setting_json.description === '' ||
              eventDesc.setting_json.description === '<p></p>' ||
              eventDesc.setting_json.description === null ||
              eventDesc.setting_json.description === undefined
            "
          >
            暂无内容
          </div>
          <div class="muContent" v-html="eventDesc.setting_json.description" />
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import EventDesc from '@/components/EventDesc.vue';
import EventMenu from '@/components/EventMenu.vue';
// import { getEventDetail } from "@/apis/eventDetail.js";
export default {
  name: 'EventDetail',
  components: {
    Breadcrumb,
    EventDesc,
    EventMenu,
  },
  mounted() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'event');
    /*
            let forum_id = this.$route.query.eventId;
            getEventDetail(forum_id).then(res => {
                if ( res.status === 200 ) {
                    if ( res.data.success === true ){
                        console.log(res.data);
                        this.eventDesc = res.data.data.item
                        this.eventDesc.setting_json = res.data.data.item.setting_json
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success',
                        });
                    }
                } else {
                    this.$message.error('未请求成功');
                }
            }).catch(error => {
                console.log(error);
            })*/
  },
  data() {
    return {
      menuActiveId: '1',
      /*
                eventDesc:{
                    //setting_json:{},
                    image_url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                    name: '北京经济论坛2020',
                    orgnizer: '中国经济学年会',
                    start_time: '2020–06-18 @ 08:00',
                    end_time: '2020–06-20 @ 16:00',
                    contacts: '曲静静',
                    tel: '18899998888',
                    submitEndTime: '2020–06-10 @ 16:00',
                    signUpEndTime: '2020–06-16 @ 16:00',
                    description: '富文本',
                },*/
    };
  },
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
  },
  watch: {
    '$store.state.toGetCurrentEvent.currentEvent'(v) {
      document.title = '会议详情 - ' + v.name;
    },
  },
};
</script>

<style scoped></style>
